<template>
  <div v-frame-fade>
    <slot></slot>
  </div>
</template>

<script>
import anime from 'animejs'

export default {
  name: 'FrameElement',
  props: {
    canAnimate: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    'frame-fade': {
      bind (el, binding, vnode) {
        anime.set(el, {
          opacity: 0
        })

        anime({
          targets: el,
          opacity: 1,
          easing: 'cubicBezier(0.55, 0.32, 0.62, 0.87)',
          duration: 1500,
          delay: 2800
        })
      }
    }
  }
}
</script>
